import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
declare var google;

@Component({
  selector: 'map',
  templateUrl: 'map.html'
})
export class MapComponent {
  @ViewChild('map') mapElement: ElementRef;
  map: any;
  @Input() lat: number;
  @Input() lng: number;
  @Input() marker_list = [];
  @Input() is_detail: boolean = false;
  @Input() is_top: boolean = false;
  marker = [];
  infoWindow = [];

  constructor(
    public navCtrl: NavController,
    public comProv: CommonProvider,
  ) {
  }

  /*ngOnChanges(changes: SimpleChanges) {
    if (changes['marker_list']) {
      this.marker_list = changes['marker_list'].currentValue;
      this.loadMap();
      this.addMarker();
    }
  }*/

  setList(lat, lng, marker_list) {
    this.lat = lat;
    this.lng = lng;
    this.marker_list = marker_list;
    this.loadMap();
    this.addMarker();
  }

  loadMap() {
    let latLng = new google.maps.LatLng(this.lat, this.lng);
    let mapOptions = {
      center: latLng,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scaleControl: false,
      scrollwheel: false,
      mapTypeControl : false,
      streetViewControl: false,
      navigationControl : false,
    }
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
  }

  addMarker() {
    let brand_list = this.comProv.getBrandList();
    let max_size = 40;
    brand_list.forEach(function(item) {
      if (item['image_url'] && item['aspect_ratio']) {
        if (item['aspect_ratio'] > 1) {
          // 横長画像
          item['image_width'] = max_size;
          item['image_height'] = max_size / item['aspect_ratio'];
        } else {
          // 縦長 or 正方形画像
          item['image_width'] = max_size * item['aspect_ratio'];
          item['image_height'] = max_size;
        }
      }
    });

    for (let i = 0; i < this.marker_list.length; i++) {
      let brand_image = null;
      let brand_data = {};
      if (this.marker_list[i]['brand_id']) {
        brand_data = brand_list.find((value) => {
          return (value['id'] == this.marker_list[i]['brand_id']);
        });
        if (brand_data && brand_data['image_url']) {
          brand_image = brand_data['image_url'];
        }
      }

      let markerLatLng = new google.maps.LatLng({lat: this.marker_list[i]['lat'], lng: this.marker_list[i]['lng']});
      let marker_set = {position: markerLatLng, map: this.map}
      if (brand_image) {
        marker_set['icon'] = {url: brand_image, scaledSize: new google.maps.Size(brand_data['image_width'], brand_data['image_height'])}
      }
      this.marker[i] = new google.maps.Marker(marker_set);
      /*let content = this.getContent(this.marker_list[i]);
      this.infoWindow[i] = new google.maps.InfoWindow({
        content: content,
      });*/
      if (this.is_detail) {
        //this.infoWindow[i].open(this.marker[i].getMap(), this.marker[i]);
        //this.markerEventNavi(i);
      } else if (this.is_top){
      } else {
        this.markerEvent(i);
      }
    }
  }

  getContent(marker_data) {
    let content:string;
    let ios = '';
    if (this.comProv.isIos()) {
      ios = ' ios';
    }

    if (marker_data['brand'] && marker_data['brand']['image_url']) {
      let image_url = this.comProv.getThumbnailUrl(marker_data['brand']['image_url'], 500);
      content = '<div class="map_marker' + ios + '">' + '<img src="' + image_url + '" width="40px" height="40px"><div><p class="name">' + this.comProv.escapeHtml(marker_data['name']) + '</p></div></div>';
    } else {
      content = '<div class="map_marker' + ios + '"><div><p class="name">' + this.comProv.escapeHtml(marker_data['name']) + '</p></div></div>';
    }
    return content;
  }

  markerEvent(i) {
    let that = this;
    this.marker[i].addListener('click', function() {
      that.navCtrl.push('ShopDetailPage',{
        shop_data: that.marker_list[i],
        shop_id: that.marker_list[i]['id']
      });
    });
  }

  markerEventNavi(i) {
    let that = this;
    this.marker[i].addListener('click', function() {
      that.comProv.goNavi(that.marker_list[i]);
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/map/map.ts